import { ArrowUpRight, Lock, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { trackContactClick } from "../lib/analytics";
import { AGENCY_ADDRESS, AGENCY_EMAIL, AGENCY_PHONE, AGENCY_PHONE_DISPLAY } from "../lib/contact";
import ConsentSettingsButton from "./ConsentSettingsButton";

export default function SiteFooter() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-main">
        <div>
          <p className="eyebrow">Pimp My Place</p>
          <h2>Votre projet mérite<br />une belle adresse.</h2>
        </div>
        <div className="footer-actions">
          <Link to="/honoraires" data-testid="footer-fees-link">Honoraires</Link>
          <Link to="/guides" data-testid="footer-guides-link">Guides locaux</Link>
          <Link to="/expertise" data-testid="footer-expertise-link">Notre expertise</Link>
          <Link to="/alertes" data-testid="footer-alerts-link">Alertes</Link>
          <Link to="/parrainage" data-testid="footer-referral-link">Parrainage 500 €</Link>
          <Link to="/confidentialite" data-testid="footer-privacy-link">Confidentialité</Link>
          <ConsentSettingsButton className="footer-consent-button" testId="footer-consent-settings-button" />
          <Link to="/estimation" className="primary-button" data-testid="footer-estimate-link">
            Démarrer mon projet <ArrowUpRight size={18} />
          </Link>
        </div>
      </div>
      <div className="footer-lower">
        <p data-testid="footer-location">
          <MapPin size={15} /> {AGENCY_ADDRESS}
        </p>
        <a
          href={`tel:${AGENCY_PHONE}`}
          onClick={() => trackContactClick("phone", "footer")}
          data-testid="footer-phone-link"
        >
          <Phone size={15} /> {AGENCY_PHONE_DISPLAY}
        </a>
        <a href={`mailto:${AGENCY_EMAIL}`} data-testid="footer-email-link">
          <Mail size={15} /> {AGENCY_EMAIL}
        </a>
        <a
          href="https://share.google/ByvWU7BP5ymFThmNm"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-google-maps-link"
        >
          <MapPin size={15} /> Google Maps
        </a>
        <div className="social-links">
          <a
            href="https://www.facebook.com/profile.php?id=100095019830107"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook-link"
            aria-label="Facebook"
          >
            <span className="facebook-glyph" aria-hidden="true">f</span>
          </a>
        </div>
        <Link to="/mandats" className="footer-admin-link" data-testid="footer-admin-link">
          <Lock size={13} /> Espace équipe
        </Link>
      </div>
    </footer>
  );
}